import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

const stringDataType: TableColumn['dataType'] = {
  type: 'string',
  formatter: (value) => (value as string) || '',
};

export const RepairModeGridColumns: Array<TableColumn> = [
  { id: 'mode', label: 'Mode', width: '15%', dataType: stringDataType },
  { id: 'description', label: 'Description', width: '55%', dataType: stringDataType },
  { id: 'isActiveDisplay', label: 'Active', width: '20%', dataType: stringDataType },
  { id: 'actions', label: '', sortDisabled: true, width: '10%' },
];
